<template>
  <el-table :data="tableData" style="width: 100%" :height="80+'vh'">
    <!-- <el-table-column prop="activeType" label="活动类型" width="80">
    </el-table-column> -->
    <el-table-column prop="timeId" label="活动年份" width="80">
    </el-table-column>
    <el-table-column prop="cooperateWay" label="合作方式" width="160">
    </el-table-column>
    <el-table-column prop="companyName" label="公司名称" width="80">
    </el-table-column>
    <el-table-column prop="contactPerson" label="联系人" width="80">
    </el-table-column>
    <el-table-column prop="position" label="职位" width="80">
    </el-table-column>
    <el-table-column prop="phoneNumber" label="手机号" width="120">
    </el-table-column>
    <el-table-column prop="wechat" label="微信" width="80">
    </el-table-column>
    <el-table-column prop="email" label="邮箱" width="120">
    </el-table-column>
    <el-table-column prop="provideResources" label="提供的资源">
    </el-table-column>
    <el-table-column prop="demand" label="希望的合作">
    </el-table-column>
  </el-table>
</template>

<script>
  export default {
    data() {
      return {
        tableData: []
      }
    },
    methods: {
      getHiringStandList() {
        let timeId = new Date().getFullYear(),
          activeType = 'hkstock'
        this.$http.getEnrollList({
          timeId,
          activeType
        }).then(res => {
          this.tableData = res.data.result
        })
      }
    },
    created() {
      this.getHiringStandList()
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/backend/hiringStandList.vue